import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import zhTw from '../locales/zh-tw';
import en from '../locales/en';
import id from '../locales/id';
import th from '../locales/th';
import vi from '../locales/vi';

const messages = {
  'zh-tw': zhTw,
  en,
  id,
  th,
  vi,
}

// Create VueI18n instance with options
export default new VueI18n({
  locale: 'zh-tw',
  messages,
})
